import newFormMask from "./components/newFormMask";
newFormMask();

import { catalogSelect } from "./components/catalogSelect";
try {
  catalogSelect();
} catch (e) {}

import modal from "./components/modal";
modal();

import modalRental from "./components/modalRental";
modalRental();

import choices from "./components/choices";
choices();

// import mask from "./components/mask";
// mask();

import form from "./components/form";
form();

import formCallback from "./components/formCallback";
formCallback();

import formRental from "./components/formRental";
formRental();

import customSelect from "./components/customSelect";
customSelect();

import accordion from "./components/accordion";
accordion("[data-accordion]");

import rangeSlider from "./components/rangeSlider";
rangeSlider("[data-range-slider]");

import filterMobile from "./components/filterMobile";
filterMobile();

import filterDesktop from "./components/filterDesktop";
filterDesktop();



import carCategories from "./components/carCategories";
carCategories();

import video from "./components/video";
video();

import carPageTabs from "./components/carPageTabs";
carPageTabs();

import newModalRent from "./components/newModalRent";
newModalRent();



// import priceTable from "./components/priceTable";
// priceTable()

import photoSwipe from "./components/photoSwipe";

import headerNav from "./components/headerNav";

import inputArrowControls from "./components/inputArrowControls";
inputArrowControls(".input-shell-arrow-controls");

import catalogContainer from "./components/catalogContainer";
catalogContainer();

import rentTable from "./components/rentTable";
rentTable();

import rentDates from "./components/rentDates";
rentDates();

import carSound from "./components/carSound";
carSound();

import rentEquipment from "./components/rentEquipment";
rentEquipment();

import headerSearch from "./components/headerSearch";
headerSearch();

import header from "./components/header";
header();

import tooltip from "./components/tooltip";
tooltip();

import certificate from "./components/certificate";
certificate();

import certificateForm from "./components/certificateForm";
try {
  certificateForm();
} catch (e) {}

import phoneMask from "./components/phoneMask";

import reviewRadio from "./components/reviewsRadio";
try {
  reviewRadio();
} catch (e) {}

import reviewsShow from "./components/reviewsShow";
try {
  reviewsShow();
} catch (e) {}

import additProdCustom from "./components/additProdCustom";
// import brookAnimation from "./components/brookAnimation";
// try {
//   brookAnimation();
// } catch (e) {
//   console.error("Ошибка в GSAP", e);
// }

import driverAccordion from "./components/driverAccordion";
try {
  driverAccordion();
} catch (error) {}

import servisCard from "./components/servisCard";
try {
  servisCard();
} catch (error) {}

import calcArrow from "./components/calcArrow";
try {
  calcArrow();
} catch (error) {}

import swiper from "./components/swiper";
swiper();


import carBrands from "./components/carBrands";
carBrands();

import tabsScrollTo from "./components/tabsScrollTo";
try {
  tabsScrollTo();
} catch (error) {}

import newMainFilter from "./components/newMainFilter";
newMainFilter();

import showMore from "./components/showMore";
showMore();

import slideMenu from "./components/slideMenu";
slideMenu();